import { render, staticRenderFns } from "./NotionsEditor.vue?vue&type=template&id=1b4818b8"
import script from "./NotionsEditor.vue?vue&type=script&lang=js"
export * from "./NotionsEditor.vue?vue&type=script&lang=js"
import style0 from "./NotionsEditor.vue?vue&type=style&index=0&id=1b4818b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports